import React, {Component} from "react";
import CardRow from "../../../../shared/components/Styled/Card/CardRow.jsx";
import CardCol from "../../../../shared/components/Styled/Card/CardCol.jsx";
import {Field, reduxForm} from "redux-form";

import createOnSubmitFailHandler from "../../Form/createOnSubmitFailHandler.js";
import Input from "../../Form/Field/Input.jsx";

import {connect} from "react-redux";
import validate from "./validate.js";

export const name = 'EditPasswordForm'

class EditPasswordForm extends Component {
  matchInput = (input, allInputs) => {
    if(!allInputs || !allInputs.newPassword || !allInputs.newPassword.password || !allInputs.newPassword.confirmation) {
      return undefined
    }
    return  allInputs.newPassword.password === allInputs.newPassword.confirmation ? undefined: 'Le nouveau mot de passe et le mot de passe de confirmation ne correspondent pas'
  }

  render() {
    return (
      <div id={name}>
        <form>
          <CardRow gap={'10px'}>
            <CardCol flex="1">
              <Field
                label="Ancien mot de passe"
                name="oldPassword"
                placeholder=""
                type="password"
                component={Input}
              />
            </CardCol>
            <CardCol flex="1">
              <CardRow gap={'00px'} direction="column">
                <CardCol>
                  <Field
                    label="Nouveau mot de passe"
                    name="newPassword.password"
                    placeholder=""
                    type="password"
                    component={Input}
                  />
                </CardCol>
                <CardCol>
                  <Field
                    label="Confirmer votre nouveau mot de passe"
                    name="newPassword.confirmation"
                    placeholder=""
                    type="password"
                    validate={[this.matchInput]}
                    required="true"
                    component={Input}
                  />
                </CardCol>
              </CardRow>
            </CardCol>
          </CardRow>
        </form>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    currentUniverse: state.universe.currentUniverse,
  }),
)(reduxForm({
  form: name,
  validate,
  onSubmitFail: createOnSubmitFailHandler(name),
})(EditPasswordForm));

